import { AdminDashboard } from '../types/interfaces';
import apiClient from './config';

export const getAdminDashboard = () =>
  apiClient.get<AdminDashboard>('/admin/dashboard');
